export enum ActionType {
    MOVETO,
    MOVEEND,
    LINETO,
    UNDO,
    REDO,
    CLEAR
}
